"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomAttributes = exports.updateCustomAttributes = exports.setCustomAttributes = exports.subscribeToEvent = exports.initWebMessenger = exports.initLiveMessenger = exports.isLauncherReady = void 0;
var api_1 = require("./api");
var utils_1 = require("./utils");
var constants_1 = require("./constants");
var custom_launcher_1 = require("./custom-launcher");
var tracking_1 = require("./tracking");
var isLauncherReady = function () { return !!window.__GENESYS_READY; };
exports.isLauncherReady = isLauncherReady;
var waitForLauncher = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function check(resolve) {
                    if (window.Genesys) {
                        window.Genesys('subscribe', 'Launcher.ready', function () {
                            window.__GENESYS_READY = true;
                            resolve();
                        });
                    }
                    else {
                        setTimeout(check, 100);
                    }
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var initLiveMessenger = function (_a) {
    var _b = _a.environment, environment = _b === void 0 ? 'production' : _b, _c = _a.initialQueue, initialQueue = _c === void 0 ? 'YS_Chat_Support_YSR2000' : _c, _d = _a.debug, debug = _d === void 0 ? false : _d, _e = _a.zIndex, zIndex = _e === void 0 ? '1' : _e;
    return __awaiter(void 0, void 0, void 0, function () {
        var accountNumbers;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (window.Genesys) {
                        // Genesys is already initialized
                        return [2 /*return*/];
                    }
                    (function (g, e, n, es) {
                        g._genesysJs = e;
                        g[e] =
                            g[e] ||
                                function () {
                                    (g[e].q = g[e].q || []).push(arguments);
                                };
                        g[e].t = 1 * new Date().getTime();
                        g[e].c = es;
                        var ys = document.createElement('script');
                        ys.async = true;
                        ys.src = n;
                        ys.charset = 'utf-8';
                        document.head.appendChild(ys);
                    })(window, 'Genesys', 'https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js', {
                        environment: 'prod-euc1',
                        deploymentId: 'b611337f-0f98-4e5e-8039-f8e4c06fccde',
                        debug: debug,
                    });
                    return [4 /*yield*/, waitForLauncher()];
                case 1:
                    _f.sent();
                    // set default custom attributes
                    (0, exports.updateCustomAttributes)({
                        queue: initialQueue,
                        isLoggedIn: false,
                        accountNumbers: '',
                        environment: environment,
                    });
                    return [4 /*yield*/, (0, api_1.fetchAccountInfo)(environment !== null && environment !== void 0 ? environment : 'staging')];
                case 2:
                    accountNumbers = _f.sent();
                    if (accountNumbers) {
                        (0, exports.updateCustomAttributes)({
                            isLoggedIn: true,
                            accountNumbers: accountNumbers,
                        });
                    }
                    (0, exports.subscribeToEvent)('Conversations.closed', function () {
                        (0, tracking_1.event)({ formType: 'chat', formStatus: 'closed' });
                    });
                    setIframeZIndex(zIndex);
                    // make sure the live messenger is always on top of the page when it is open
                    (0, exports.subscribeToEvent)('Messenger.opened', function () {
                        setIframeZIndex('');
                        (0, custom_launcher_1.toggleLauncherVisibility)(false);
                        (0, tracking_1.event)({ formType: 'chat', formStatus: 'open' });
                    });
                    (0, exports.subscribeToEvent)('Messenger.closed', function () {
                        setIframeZIndex(zIndex);
                        (0, custom_launcher_1.toggleLauncherVisibility)(true);
                        (0, tracking_1.event)({ formType: 'chat', formStatus: 'minified' });
                    });
                    // Hide the out-of-the-box-launcher
                    return [4 /*yield*/, (0, custom_launcher_1.hideLauncher)()];
                case 3:
                    // Hide the out-of-the-box-launcher
                    _f.sent();
                    // Add a custom launcher button
                    (0, custom_launcher_1.addCustomLauncherButton)();
                    // Add hotjar tracking block
                    (0, utils_1.addHotjarSuppress)();
                    return [2 /*return*/];
            }
        });
    });
};
exports.initLiveMessenger = initLiveMessenger;
var getDeploymentId = function (environment) {
    var deploymentId;
    switch (environment) {
        case 'production':
            deploymentId = constants_1.deployment.PRODUCTION;
            break;
        case 'test':
            deploymentId = constants_1.deployment.TESTBOT;
            break;
        default:
            deploymentId = constants_1.deployment.STAGING;
    }
    return deploymentId;
};
var initWebMessenger = function (_a) {
    var _b = _a.environment, environment = _b === void 0 ? 'staging' : _b, _c = _a.initialQueue, initialQueue = _c === void 0 ? 'YS_Chat_Support' : _c, _d = _a.debug, debug = _d === void 0 ? false : _d, _e = _a.zIndex, zIndex = _e === void 0 ? '1' : _e;
    return __awaiter(void 0, void 0, void 0, function () {
        var deploymentId, accountNumbers;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (window.Genesys) {
                        // Genesys is already initialized
                        return [2 /*return*/];
                    }
                    deploymentId = getDeploymentId(environment);
                    // init the web messenger https://developer.genesys.cloud/commdigital/digital/webmessaging/messengersdk/genesysgf#single-snippet
                    (function (g, e, n, es) {
                        g._genesysJs = e;
                        g[e] =
                            g[e] ||
                                function () {
                                    (g[e].q = g[e].q || []).push(arguments);
                                };
                        g[e].t = new Date().getTime();
                        g[e].c = es;
                        var ys = document.createElement('script');
                        ys.async = true;
                        ys.src = n;
                        ys.charset = 'utf-8';
                        document.head.appendChild(ys);
                    })(window, 'Genesys', 'https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js', {
                        environment: 'euc1',
                        deploymentId: deploymentId,
                        debug: debug,
                    });
                    return [4 /*yield*/, waitForLauncher()];
                case 1:
                    _f.sent();
                    // set default custom attributes
                    (0, exports.updateCustomAttributes)({
                        queue: initialQueue,
                        isLoggedIn: false,
                        accountNumbers: '',
                        environment: environment,
                    });
                    return [4 /*yield*/, (0, api_1.fetchAccountInfo)(environment !== null && environment !== void 0 ? environment : 'staging')];
                case 2:
                    accountNumbers = _f.sent();
                    if (accountNumbers) {
                        (0, exports.updateCustomAttributes)({
                            isLoggedIn: true,
                            accountNumbers: accountNumbers,
                        });
                    }
                    (0, exports.subscribeToEvent)('Conversations.closed', function () {
                        (0, tracking_1.event)({ formType: 'chat', formStatus: 'closed' });
                    });
                    setIframeZIndex(zIndex);
                    // make sure the web messenger is always on top of the page when it is open
                    (0, exports.subscribeToEvent)('Messenger.opened', function () {
                        setIframeZIndex('');
                        (0, custom_launcher_1.toggleLauncherVisibility)(false);
                        (0, tracking_1.event)({ formType: 'chat', formStatus: 'open' });
                    });
                    (0, exports.subscribeToEvent)('Messenger.closed', function () {
                        setIframeZIndex(zIndex);
                        (0, custom_launcher_1.toggleLauncherVisibility)(true);
                        (0, tracking_1.event)({ formType: 'chat', formStatus: 'minified' });
                    });
                    // Hide the out-of-the-box-launcher
                    return [4 /*yield*/, (0, custom_launcher_1.hideLauncher)()];
                case 3:
                    // Hide the out-of-the-box-launcher
                    _f.sent();
                    // Add a custom launcher button
                    (0, custom_launcher_1.addCustomLauncherButton)();
                    // Add hotjar tracking block
                    (0, utils_1.addHotjarSuppress)();
                    return [2 /*return*/];
            }
        });
    });
};
exports.initWebMessenger = initWebMessenger;
var setIframeZIndex = function (zIndex) {
    if (zIndex === void 0) { zIndex = '1'; }
    var webMessengerIframe = document === null || document === void 0 ? void 0 : document.getElementById('genesys-mxg-frame');
    if (webMessengerIframe) {
        webMessengerIframe.style.zIndex = zIndex;
    }
};
var subscribeToEvent = function (event, callback) {
    if (!window.Genesys) {
        // Genesys is not initialized
        return;
    }
    window.Genesys('subscribe', event, callback);
};
exports.subscribeToEvent = subscribeToEvent;
var setOrUpdateDatabase = function (set, values) {
    if (set === void 0) { set = true; }
    if (!window.Genesys) {
        // Genesys is not initialized
        return;
    }
    var databaseValues = {
        messaging: {
            customAttributes: values,
        },
    };
    set
        ? window.Genesys('command', 'Database.set', databaseValues)
        : window.Genesys('command', 'Database.update', databaseValues);
};
var setCustomAttributes = function (values) {
    setOrUpdateDatabase(true, values);
};
exports.setCustomAttributes = setCustomAttributes;
var updateCustomAttributes = function (values) {
    setOrUpdateDatabase(false, values);
};
exports.updateCustomAttributes = updateCustomAttributes;
var getCustomAttributes = function () { return __awaiter(void 0, void 0, void 0, function () {
    var promise, fullResult;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!window.Genesys) {
                    // Genesys is not initialized
                    return [2 /*return*/, {}];
                }
                promise = new Promise(function (resolve) {
                    var _a;
                    try {
                        (_a = window.Genesys) === null || _a === void 0 ? void 0 : _a.call(window, 'command', 'Database.get', {}, function (result) {
                            resolve(result);
                        });
                    }
                    catch (e) {
                        resolve({});
                    }
                });
                return [4 /*yield*/, promise];
            case 1:
                fullResult = _b.sent();
                if (!((_a = fullResult === null || fullResult === void 0 ? void 0 : fullResult.messaging) === null || _a === void 0 ? void 0 : _a.customAttributes)) {
                    return [2 /*return*/, {}];
                }
                return [2 /*return*/, fullResult.messaging.customAttributes];
        }
    });
}); };
exports.getCustomAttributes = getCustomAttributes;
//# sourceMappingURL=messenger.js.map